import { FieldErrors } from "react-hook-form";
import { logAndNotifyError } from "../../modules/logger";
import { Colors } from "../../modules/Colors";

interface IProps {
  errors: FieldErrors<any>;
  useFullMessages?: boolean;
}

const ValidationSummaryMessages = ({ errors, useFullMessages }: IProps) => {
  const messages: any[] = [];

  const extractErrors = (errInfo: any, errArr: any[], keyPrefix: string) => {
    Object.keys(errInfo).forEach((fieldName: any) => {
      const fieldValidations = errInfo[fieldName];
      if (Array.isArray(fieldValidations)) {
        for (let arrKey in fieldValidations) {
          const arrEntry = fieldValidations[arrKey];
          if (arrEntry !== undefined) extractErrors(arrEntry, messages, keyPrefix + arrKey);
        }
      } else if (fieldValidations instanceof Object && !(fieldValidations.type && fieldValidations.message)) {
        extractErrors(fieldValidations, errArr, keyPrefix + "." + fieldName);
      } else {
        var entry = { key: keyPrefix + fieldName, message: fieldValidations?.message?.toString() };
        messages.push(entry);
      }
    });
  };

  try {
    extractErrors(errors, messages, "");

    var dbg = messages;
  } catch (e) {
    logAndNotifyError(e);
  }

  const errorsCount = messages.length;
  const generalMessage = messages.length > 0 ? `Det finns ${errorsCount} fel i formuläret` : "";

  return (
    <>
      {useFullMessages ? (
        <>
          {messages.map((e) => (
            <div key={e.key}>{e.message}</div>
          ))}
        </>
      ) : (
        <div style={{ color: Colors.RedMedium }}>{generalMessage}</div>
      )}
    </>
  );
};

export default ValidationSummaryMessages;
